import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {Box, Container, IconButton, Button} from "@mui/material";
import {TerminalReleaseList} from "~/apps/packages/warehouse-closure/components/TerminalReleaseList/TerminalReleaseList";
import {AddCircle, ArrowBack} from "@mui/icons-material";
import {useHistory} from "react-router-dom";
import {SearchAppBar} from "~/apps/core/ui/SearchAppBar";
import {TerminalReleaseState} from "~/apps/packages/warehouse-closure/queries";
import {TerminalReleaseStatesChipInput} from "~/apps/packages/warehouse-closure/components/TerminalReleaseStatesChipInput";
import {FloatingActions} from "~/apps/core/ui/FloatingActions";
import {useHistoryState} from "~/apps/core/utils";
import {tuple} from "~/types";
import {FiltersBar} from "~/apps/core/ui/FiltersBar";
import {AbsoluteContainer} from "~/apps/core/ui/AbsoluteContainer";
import {useChangeEffect} from "~/lib/useChangeEffect";


type FilterState = {
    search?: string
    states?: TerminalReleaseState[]
}

function useFilterState() {
    const [value, setValue, delValue] = useHistoryState<FilterState>({
        name: "filter",
        serialize: state => JSON.stringify(state),
        deserialize: value => JSON.parse(value),
        handleBack: false,
    });

    const filter = useMemo(() => {
        const filter: FilterState = {};
        if (typeof value == "object") {
            if (typeof value.search == "string" && value.search.length > 0) {
                filter.search = value.search;
            }
            if (Array.isArray(value?.states) && value.states.length > 0) {
                filter.states = value.states;
            }
        }
        return Object.keys(filter).length ? filter : null;
    }, [value]);

    const setFilter = useCallback(async value => {
        if (value?.search?.length > 0 || value?.states?.length > 0) {
            await setValue(value);
        } else {
            await delValue();
        }
    }, [setValue, delValue]);

    return tuple(filter, setFilter);
}


export const IndexPage = () => {
    const $container = useRef<HTMLDivElement>();
    const history = useHistory();
    const [filter, setFilter] = useFilterState();
    const title = filter?.search || "Закрытие склада";

    useChangeEffect(() => {
        $container.current?.scrollTo(0, 0);
    }, [filter])

    const handleCreateClick = () => {
        history.push("/new");
    }

    const handleStatusChange = (value) => {
        setFilter({
            ...filter,
            states: value
        }).then(() => null);
    }

    const handleQueryChange = (value) => {
        setFilter({
            ...filter,
            search: value
        }).then(() => null);
    }

    return <>
        <SearchAppBar
            color="default"
            title={title}
            query={filter?.search}
            onSearch={handleQueryChange}
        >
            <FiltersBar>
                <TerminalReleaseStatesChipInput
                    value={filter?.states}
                    onChange={handleStatusChange}
                />
            </FiltersBar>
        </SearchAppBar>

        <AbsoluteContainer disableGutters top={104} ref={$container}>
            <TerminalReleaseList
                states={filter?.states}
                query={filter?.search}
            />
            <Box minHeight="80px"/>
            <FloatingActions>
                <Button fullWidth onClick={handleCreateClick} color="primary" startIcon={<AddCircle/>}>
                    Создать заявку
                </Button>
            </FloatingActions>
        </AbsoluteContainer>
    </>;
}